
/* 商城相关 */
// 订单状态
export const orderStatusType = (status) => {
  let type = '';

  if (!status) {
    type = 'default';
  } else if (status == 1) {
    type = 'warning';
  } else if (status == 2) {
    type = 'primary';
  } else if (status == 3) {
    type = 'success';
  }

  return type;
}

// 预约状态
export const yyStatusType = (status) => {
  let type = '';

  if (!status) {
    type = 'default';
  } else if (status == 1) {
    type = 'warning';
  } else if (status == 2) {
    type = 'success';
  } else if (status == 9) {
    type = 'danger';
  }

  return type;
}